// extracted by mini-css-extract-plugin
export default {"file_type":"fileType_file_type__WRVTO"};